<template>
    <BasePage>
        <div class="container">
            <!-- The key makes both follow the route: a new product URL builds them afresh. -->
            <ProductDetails :key="$route.path"></ProductDetails>
            <FBT :key="'fbt-' + $route.path"></FBT>
        </div>
    </BasePage>
</template>

<script>
import BasePage from "@/components/BasePage.vue";
import ProductDetails from "@/components/ProductDetails.vue";
import FBT from "@/components/FBTComponent.vue";
export default {
    components: {
        FBT,
        ProductDetails,
        BasePage
    }
}
</script>
